module.exports = {
  add_to_calendar: 'Add to Calendar',
  all_appointments: 'All Appointments',
  appointment_details: 'Appointment Details',
  appointment_location: 'Location',
  appointment_manager: 'Appointment manager',
  appointments: 'Appointment|Appointments',
  cancelled: 'Cancelled',
  cancellationDeadlinePassed: 'Cancellation is no longer possible as the cancellation deadline has passed.',
  elapsed: 'Past',
  last_updated_at: 'Last updated at %{date}',
  next_appointments: 'Next Appointments',
  see_all: 'See all appointments',
  upcoming: 'Current',
  openSlots: 'open slots',
  nOpenSlots: '1 open slot|%{openSlots} open slots',
  noOpenSlots: 'no open slots',
  register: 'Register',
  registrationDeadlineInfo: 'Registration is possible until %{deadline}',
  registrationDeadlinePastInfo: 'Registration was possible until %{deadline}',
  registrationDeadlinePassed: 'Registration is no longer possible as the registration deadline has passed.',
  unregister: 'Cancel registration',
  notAllowedToRegister: 'You do not have the required permissions to participate in this appointment. Please contact your administrator to obtain the required rights.',
  nUsersAlreadyRegistered: '<strong>1 person</strong> already participates|<strong>%{participantsCount} others</strong> already participate',
  nUsersAlsoRegistered: '<strong>1 person</strong> participates as well|<strong>%{participantsCount} others</strong> participate as well',
  isFullyBooked: 'Event is fully booked',
  youAreRegistered: 'You are participating',
  registeredSuccessfully: 'You are now registered for this event',
  unregisteredSuccessfully: 'You are no longer registered for this event',
  download_certificate: 'Download Certificate',
  your_certificate: 'Your Certificate',
  certificate_preview: 'Certificate preview',
  certificate_acquired: 'Certificate acquired',
  with_certificate: 'With certificate',
  search_appointment: 'Search appointments...',
  participating: 'My appointments',
  online: 'Online',
  in_person: 'In-person',
  past: 'Expired',
  no_appointments_found: 'No appointments found',
  show_all: 'Show all',
  show_less: 'Show less',
  sortLabels: {
    name_asc: 'Alphabetically (A-Z)',
    name_desc: 'Alphabetically (Z-A)',
    start_date_desc: 'Date (newest first)',
    start_date_asc: 'Date (oldest first)',
    relevant: 'Most relevant',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    name_desc: 'Z-A',
    start_date_desc: 'Newest',
    start_date_asc: 'Oldest',
    relevant: 'Most relevant',
  },
}
